module.exports = {"350724001":"松源街道","350724101":"郑墩镇","350724102":"渭田镇","350724200":"河东乡","350724201":"茶平乡","350724202":"旧县乡","350724203":"溪东乡","350724204":"花桥乡","350724205":"祖墩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350724.json
// module id = 1337
// module chunks = 0